const Workshop = () => {
    return (
        <div></div>
    );
}
export default Workshop;